import { useQuery } from '@tanstack/react-query';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface HookProps {
  batchName: string;
}
export const searchBatchName = async (batchName: string): Promise<{ name: string; id: string }[]> => {
  try {
    return await request({
      path: `batches/search-batch-name`,
      method: 'POST',
      authenticate: true,
      dataObject: {
        name: batchName,
      },
    });
  } catch (error) {
    showErrorToast(error, 'Error searching the batch name!');
  }
};

export const useBatchesByName = ({ batchName }: HookProps) =>
  useQuery({
    queryKey: ['batches', batchName],
    queryFn: () => searchBatchName(batchName),
    placeholderData: [],
  });
